module.exports = __webpack_public_path__ + "img/image00004.8a4a0e21.jpeg";